import _uniq from "lodash/uniq";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import { ANSWER_SOURCE, QUESTION_FLOW } from "lib/constants";
import { getCurrentQuestion } from "redux/questions/selectors";
import { ownPropsPriority } from "redux/utils";

import Questions from "../Questions";

const mapStateToProps = (state) => ({
    companyCount: _uniq(state.questions.questions.map((q) => q.company_name)).length,
    current: state.questions.current,
    question: getCurrentQuestion(state),
    questionCount: state.questions.questions.length,
});

const CandidateApplicationQuestions = ({
    companyCount,
    current,
    forSuggestions,
    handleCompleted,
    questionCount,
}) => {
    let header;
    if (forSuggestions) {
        header = (
            <header className="app-questions__header app-questions__header--highlight">
                A few more questions based on the jobs you just added:
            </header>
        );
    } else {
        const company = companyCount === 1 ? "company" : "companies";
        header = (
            <header className="app-questions__header">
                Answer a few questions directly from the {company} you&apos;re applying to:
            </header>
        );
    }

    return (
        <div className="app-questions">
            {header}
            <div className="app-questions__container">
                <div className="app-questions__progress">
                    {current + 1} of {questionCount}
                </div>
                <Questions
                    autoSelect
                    canUndo
                    flow={QUESTION_FLOW.APP}
                    handleCompleted={handleCompleted}
                    source={ANSWER_SOURCE.APP}
                />
            </div>
        </div>
    );
};

CandidateApplicationQuestions.propTypes = {
    companyCount: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    forSuggestions: PropTypes.bool.isRequired,
    handleCompleted: PropTypes.func.isRequired,
    questionCount: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, null, ownPropsPriority)(CandidateApplicationQuestions);
